var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { IsDate, IsEnum, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
export var AccessType;
(function (AccessType) {
    AccessType[AccessType["SEARCH_RESULT"] = 0] = "SEARCH_RESULT";
    AccessType[AccessType["FULL_RECORD"] = 1] = "FULL_RECORD";
    AccessType[AccessType["IDENTIFIED_RECORD_REQUESTED"] = 2] = "IDENTIFIED_RECORD_REQUESTED";
    AccessType[AccessType["IDENTIFIED_RECORD"] = 3] = "IDENTIFIED_RECORD";
})(AccessType || (AccessType = {}));
export class AccessLedgerSearchInput {
}
__decorate([
    IsString(),
    IsOptional()
], AccessLedgerSearchInput.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AccessLedgerSearchInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AccessLedgerSearchInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(AccessType, { each: true }),
    IsOptional()
], AccessLedgerSearchInput.prototype, "accessTypes", void 0);
__decorate([
    IsOptional(),
    Type(() => Date),
    IsDate()
], AccessLedgerSearchInput.prototype, "timestampStart", void 0);
__decorate([
    IsOptional(),
    Type(() => Date),
    IsDate()
], AccessLedgerSearchInput.prototype, "timestampEnd", void 0);
export class AccessRecordInput {
}
__decorate([
    IsString()
], AccessRecordInput.prototype, "healthcareOrganizationId", void 0);
__decorate([
    IsString()
], AccessRecordInput.prototype, "patientId", void 0);
__decorate([
    IsString()
], AccessRecordInput.prototype, "studyId", void 0);
__decorate([
    IsEnum(AccessType)
], AccessRecordInput.prototype, "accessType", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], AccessRecordInput.prototype, "timestamp", void 0);
export class AccessRecord extends AccessRecordInput {
}
__decorate([
    IsString()
], AccessRecord.prototype, "id", void 0);
export class AccessLedgerSearchResult {
}
__decorate([
    IsNumber()
], AccessLedgerSearchResult.prototype, "total", void 0);
__decorate([
    Type(() => AccessRecord),
    ValidateNested({ each: true })
], AccessLedgerSearchResult.prototype, "results", void 0);
